import { GridToolbarContainer, GridToolbarExport } from "@mui/x-data-grid";

export default function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarExport csvOptions={{ utf8WithBom: true }} />
      </GridToolbarContainer>
    );
  }